
import { FETCH_LIST_REQUEST, FETCH_LIST_SUCCESS, FETCH_LIST_FAILURE,REDIRECT_TO_LOGIN } from './actionsTypes';

export const fetchListRequest = (token,history) => ({
  type: FETCH_LIST_REQUEST,
  payload: { token,history },
});

export const fetchListSuccess = (lastSubData) => ({
  type: FETCH_LIST_SUCCESS,
  payload: { lastSubData },
});

export const fetchListFailure = (error) => ({
  type: FETCH_LIST_FAILURE,
  payload: { error },
});

export const redirectToLogin = () => ({
  type: REDIRECT_TO_LOGIN,
});
